// Регистрация панелей ведомости в каркасе. Побочный эффект при загрузке модуля: раздел
// объявляет, что умеет рисовать в стопке панелей, а каркас остаётся без знания о нём.

import { registerPanel } from '@/layout/panel-registry';

import {
  PANEL_SHEET_ADD,
  PANEL_SHEET_GENERATE,
  PANEL_SHEET_PERSON,
  PANEL_SHEET_RECALC,
  PANEL_SHEET_REVIEW,
  PANEL_SHEET_TARIFF,
  PANEL_SHEET_ROW,
} from '../../route';

import { AddPersonPanel } from './AddPersonPanel';
import { GeneratePanel } from './GeneratePanel';
import { PersonPanel } from './PersonPanel';
import { RecalcPeriodPanel } from './RecalcPeriodPanel';
import { ReviewPanel } from './ReviewPanel';
import { RowPanel } from './RowPanel';
import { TariffPanel } from './TariffPanel';

registerPanel(PANEL_SHEET_ROW, {
  title: () => 'Тарифная строка',
  render: ({ id }) => <RowPanel id={id} />,
});

registerPanel(PANEL_SHEET_PERSON, {
  title: () => 'Расчёт по человеку',
  render: ({ id }) => <PersonPanel id={id} />,
});

registerPanel(PANEL_SHEET_REVIEW, {
  title: () => 'Разбор замечаний',
  render: ({ id }) => <ReviewPanel id={id} />,
});

registerPanel(PANEL_SHEET_ADD, {
  title: () => 'Добавить в ведомость',
  render: ({ id, onClose }) => <AddPersonPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_SHEET_GENERATE, {
  title: () => 'Создать ведомость',
  render: ({ id }) => <GeneratePanel id={id} />,
});

registerPanel(PANEL_SHEET_RECALC, {
  title: () => 'Пересчёт периода',
  render: ({ id }) => <RecalcPeriodPanel id={id} />,
});

registerPanel(PANEL_SHEET_TARIFF, {
  title: () => 'Тарифы: чего не хватает',
  render: ({ id }) => <TariffPanel id={id} />,
});
